import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonApostrofosKentimata';
const args = {};

export class OligonApostrofosKentimata extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
